// removed by extract-text-webpack-plugin
module.exports = {"NotificationWrapper":"styles__NotificationWrapper___1VK-Q","LowerNotification":"styles__LowerNotification___MXVqp","Notification":"styles__Notification___3rSMe","Message":"styles__Message___1HmNC","Visible":"styles__Visible___1VE5S","MessageIcon":"styles__MessageIcon___eWqN2","MessageClose":"styles__MessageClose___2hOoX","Cancel":"styles__Cancel___3L5GC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/styles.scss
// module id = 1445
// module chunks = 0